import { type ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export default function CacheErrorBoundary({ children }: { children: ReactNode }) {
  const [hasChunkError, setHasChunkError] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    const handleViteError = (event: Event) => {
      event.preventDefault();
      setHasChunkError(true);
    };

    window.addEventListener('vite:preloadError', handleViteError);

    return () => window.removeEventListener('vite:preloadError', handleViteError);
  }, []);

  if (hasChunkError) {
    return (
      <div className="flex flex-col items-center justify-center h-screen gap-4 bg-background p-5">
        <h1 className="text-xl font-semibold text-foreground">
          {t('errors.cache.component.title')}
        </h1>
        <p className="font-normal text-sm text-muted-foreground text-center">
          {t('errors.cache.component.description')}
        </p>
        <Button
          variant="default"
          onClick={() => window.location.reload()}
          className="font-medium text-sm mt-4"
        >
          {t('errors.cache.action')}
        </Button>
      </div>
    );
  }

  return <>{children}</>;
}
